import {
  RemoveCustomOptionsError,
  SetCustomOptions,
  SetLoadCustomOptionsError,
  SetRawSchema,
} from './customOptions.actions';
import { CustomOptions } from './customOptions.model';
import { CustomOptionsApiError } from './customOptions.error';
import { createReducer, on } from '@ngrx/store';

export interface CustomOptionsState {
  options: CustomOptions;
  error?: CustomOptionsApiError;
  rawOptions?: any;
}

export const initialCustomOptionsState: CustomOptionsState = {
  options: null,
  error: null,
  rawOptions: null,
};

export const customOptionsReducer = createReducer(
  initialCustomOptionsState,
  on(SetCustomOptions, (state, { options }) => ({ ...state, options })),
  on(SetLoadCustomOptionsError, (state, { error }) => ({ ...state, error })),
  on(RemoveCustomOptionsError, (state) => ({ ...state, error: null })),
  on(SetRawSchema, (state, { payload }) => ({ ...state, rawOptions: payload })),
);
